<template>
  <div class="page-content animate__animated animate__fadeIn">
    <div class="border-bottom" style="margin-top:0;">
      <!-- 顶部搜索框 -->
      <div>
        <el-form :inline="true" :model="queryParams" class="demo-form-inline">
          <el-form-item label="线路" prop="circuitId">
            <el-select clearable v-model="queryParams.circuitId" placeholder="请选择线路">
              <el-option v-for="item in circuitList" :key="item.circuitId" :label="item.circuitName"
                :value="item.circuitId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区站">
            <el-input v-model="queryParams.stationName" placeholder="请输入区站进行查询" class="form-item-width"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="行别" prop="lineType">
            <el-select clearable v-model="queryParams.lineType" placeholder="请选择行别">
              <el-option label="单线" value="0"></el-option>
              <el-option label="上行" value="1"></el-option>
              <el-option label="下行" value="2"></el-option>
            </el-select>
          </el-form-item>

          <div class="btn-boxs">
            <div>
              <el-button icon="el-icon-plus" type="primary" @click="handlestationAdd">新 增</el-button>
              <el-button :disabled="!multipleSelection.length" icon="el-icon-delete" type="danger"
                @click="batchDelete">批量删除</el-button>
            </div>
            <div>
              <el-button icon="el-icon-search" type="primary" @click="onSearch">查 询</el-button>
              <el-button icon="el-icon-refresh" @click="onReset">重 置</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="margin-top" style="margin-bottom:0;margin-top:15px">
      <!-- 表格组件 -->
      <el-table :data="tableData" v-loading="tableLoading" border row-key="deptId" default-expand-all
        :tree-props="{ children: 'children' }" highlight-current-row max-height="447"
        :header-cell-style="{ background: '#fafafa', color: '#606266', fontSize: '14px' }"
        @selection-change="handleSelectionChange">
        <!-- 多选 -->
        <el-table-column type="selection" width="55"></el-table-column>
        <!-- 序号列 -->
        <el-table-column align="center" type="index" label="序号" width="50"></el-table-column>
        <!-- 动态生成其他列 -->
        <el-table-column align="center" v-for="tab in tableTitle" :key="tab.code" :label="tab.name"
          show-overflow-tooltip :width="tab.width">
          <template slot-scope="scope">
            <!-- 针对 status 列的特殊处理 -->
            <span v-if="tab.code === 'status'"
              :style="scope.row.status === '0' ? { color: 'green' } : { color: 'red' }">{{ scope.row.status === '0' ?
                '正常' : '停用' }}</span>

            <span v-else>{{ scope.row[tab.code] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="updateData(scope.row)" class="update-btn">修改</el-button>
            <el-button style="color:red" type="text" @click="deleteData(scope.row)" class="update-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <div>
        <Pagination background :total="pageParams.total" :page="pageParams.pageNum" :limit="pageParams.pageSize"
          @pagination="onChangePages" />
      </div>
    </div>
    <!-- 添加 修改角色 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisble" width="30%" @close="handleDialogClose">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="线路" prop="circuitId">
          <el-select v-model="form.circuitId" placeholder="请选择线路" @change="circuitChange">
            <el-option v-for="item in circuitList" :key="item.circuitId" :label="item.circuitName"
              :value="item.circuitId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区站名称" prop="stationName">
          <el-input v-model="form.stationName" autocomplete="off" placeholder="请输入区站名称"></el-input>
        </el-form-item>
        <el-form-item label="行别" prop="lineType">
          <el-select v-model="form.lineType" placeholder="请选择行别">
            <el-option v-for="item in lineTypeOptions" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门" prop="deptId">
          <el-cascader v-model="form.deptId" placeholder="请选择部门" :options="deptList" :show-all-levels="false"
            :props="cascaderProps" clearable></el-cascader>
        </el-form-item>

        <el-form-item label="类型" prop="type">
          <el-select v-model="form.type" placeholder="请选择类型">
            <el-option label="站场" value="0"></el-option>
            <el-option label="区间" value="1"></el-option>
            <el-option label="桥隧" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.type === '2'" label="桥隧名称" prop="bridgesTunnels">
          <el-input v-model="form.bridgesTunnels" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :icon="dialogTitle === '新增' ? 'el-icon-plus' : 'el-icon-edit'" type="primary"
          @click="submitForm('form')">{{ dialogTitle === '新增' ? '立即添加' : '立即修改' }}</el-button>
        <el-button icon="el-icon-refresh" @click="resetForm('form')">重 置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import {getStationList,stationAdd, stationById, updeteStation, deleteStation} from "@/api/data-service/station.js";
import { getDeptTree } from "@/api/admin-service/dept";
import { getCircuitAll } from "@/api/data-service/line.js";
export default {
  components: {
    Pagination
  },
  data() {
    return {
      tableLoading: false,
      cascaderProps: {
        emitPath: false,
        multiple: true,
        checkStrictly: true,
        value: "deptId",
        label: "deptName",
        children: "children"
      },
      form: {
        stationName: "", //区场名称
        circuitId: "", //
        lineType: "", //
        type: "", //
        deptId: [],
        sort: "", //排序
        bridgesTunnels: "" //桥隧名称
      },
      rules: {
        stationName: [
          { required: true, message: "请填写区站名称", trigger: "blur" }
        ],
        circuitId: [
          { required: true, message: "请选择区场", trigger: "change" }
        ],
        lineType: [
          { required: true, message: "请选择行别", trigger: "change" }
        ],
        deptId: [{ required: true, message: "请选择部门", trigger: "change" }],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        sort: [{ required: true, message: "请填写排序", trigger: "blur" }],
        bridgesTunnels: [
          { required: true, message: "请填写桥隧名称", trigger: "blur" }
        ]
      },
      dialogTitle: "",
      updateId: "", //修改数据需要的id
      dialogFormVisble: false,
      // 表格数据
      tableData: [],
      // 表格标题数组
      tableTitle: [
        { name: "线路", code: "circuitName", width: "" },
        { name: "区站", code: "stationName", width: "" },
        { name: "行别", code: "lineType", width: "" },
        // { name: "车间名称", code: "farmName", width: "" },
        { name: "管辖工区", code: "deptName", width: "" },
        { name: "类型", code: "type", width: "" },
        // { name: "排序", code: "sort", width: "" },
        { name: "桥隧名称", code: "bridgesTunnels", width: "" }
      ],
      pageParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      queryParams: {
        circuitId: "",
        stationName: "",
        lineType: ""
      },
      circuitList: [],
      multipleSelection: [],
      deptList: [],
      lineTypeOptions: [
        {
          label: "单线",
          value: "0"
        },
        {
          label: "上行",
          value: "1"
        },
        {
          label: "下行",
          value: "2"
        }
      ]
    };
  },
  mounted() {
    this.onGetDataList();
    this.queryCircuitList();
    this.queryDeptList();
  },

  methods: {
    // 这个方法会在选择线路发生变化时被调用
    circuitChange(newValue) {
      this.form.lineType = "";
      const item = this.circuitList.find(item => item.circuitId === newValue);
      if (item.type === "0") {
        // 说明是单线
        this.lineTypeOptions = [
          {
            label: "单线",
            value: "0"
          }
        ];
      } else {
        this.lineTypeOptions = [
          {
            label: "上行",
            value: "1"
          },
          {
            label: "下行",
            value: "2"
          }
        ];
      }

      // this.queryParams.stationId = "";
      // this.form.stationId = "";
      // this.form.pillarId = "";
      // this.queryStaionList(newValue);
    },
    queryDeptList() {
      getDeptTree({}).then(res => {
        this.deptList = res?.data;
        this.disableNonLeafNodes(this.deptList); // 递归处理数据
      });
    },

    // 递归禁用非叶子节点，叶子节点不禁用
    disableNonLeafNodes(data) {
      data.forEach(item => {
        // 如果当前节点有子节点
        if (item.children && item.children.length > 0) {
          item.disabled = true; // 禁用当前节点
          // 递归处理子节点
          this.disableNonLeafNodes(item.children);
        } else {
          item.disabled = false; // 叶子节点不禁用
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchDelete() {
      this.$confirm(`提示，确定要删除选中的这些数据吗？`, {
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
        // 为按钮添加图标并设置为 mini 尺寸
        confirmButtonClass: "el-icon-check el-button--mini", // 确定按钮的图标和尺寸
        cancelButtonClass: "el-icon-close el-button--mini" // 取消按钮的图标和尺寸
      })
        .then(() => {
          // 使用 map() 来获取 stationId 组成的数组
          const ids = (this.multipleSelection || []).map(
            item => item.stationId
          );
          deleteStation({ ids }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    queryCircuitList() {
      getCircuitAll({
        circuitName: "", //线路名称
        ...this.pageParams
      }).then(res => {
        this.circuitList = res?.data || [];
      });
    },
    addData() {
      this.dialogTitle = "新增";
      this.dialogFormVisble = true;
    },
    // 增 / 改
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const result = this.form.deptId.join(","); // 使用逗号作为分隔符
          const formData = { ...this.form, deptId: result };
          delete formData.stationId; // 清除 stationId
          const submitAction =
            this.dialogTitle === "新增"
              ? stationAdd(formData)
              : updeteStation({
                ...this.form,
                deptId: result,
                stationId: this.updateId
              });

          submitAction
            .then(res => {
              if (res.data) {
                this.$message.success(
                  res.msg ||
                  (this.dialogTitle === "新增" ? "新增成功！" : "修改成功！")
                );
                this.dialogFormVisble = false;
                this.onGetDataList();
              }
            })
            .catch(error => {
              console.error("提交失败", error);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删
    deleteData(row) {
      this.$confirm(`提示，确定要删除该条数据吗？`, {
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
        // 为按钮添加图标并设置为 mini 尺寸
        confirmButtonClass: "el-icon-check el-button--mini", // 确定按钮的图标和尺寸
        cancelButtonClass: "el-icon-close el-button--mini" // 取消按钮的图标和尺寸
      })
        .then(() => {
          deleteStation({ ids: [row.stationId] }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 改
    updateData(row) {
      this.dialogTitle = "修改";
      this.dialogFormVisble = true;
      this.updateId = row.stationId;
      stationById({ id: row.stationId }).then(res => {
        let {
          stationName,
          circuitId,
          lineType,
          type,
          deptIds,
          bridgesTunnels
        } = res.data;
        this.form.stationName = stationName;
        // this.form.deptId = Array.isArray(deptIds) ? deptIds : [deptIds]; // 确保是数组

        // 确保 deptIds 被转换成数组形式
        if (deptIds) {
          // 拆分逗号并去除空格，确保每项与 deptList 中的 value 对应
          this.form.deptId = deptIds.split(",").map(item => item.trim());
        } else {
          this.form.deptId = [];
        }
        this.form.circuitId = circuitId;
        this.form.bridgesTunnels = bridgesTunnels;
        this.form.lineType = String(lineType);
        this.form.type = String(type);
      });
    },
    // 查
    onGetDataList() {
      this.tableLoading = true;
      getStationList({
        ...this.queryParams,
        ...this.pageParams
      })
        .then(res => {
          const { records, total } = res.data;
          this.tableData = records.map(item => {
            return {
              ...item,
              type:
                item.type === 2 ? "桥隧" : item.type === 0 ? "站场" : "区间",
              lineType:
                item.lineType === '0'
                  ? "单线"
                  : item.lineType === '1'
                    ? "上行"
                    : "下行"
            };
          });
          this.pageParams.total = total;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    handlestationAdd() {
      this.dialogTitle = "新增";
      this.dialogFormVisble = true;
    },
    handleDialogClose() {
      this.resetForm("form");
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 查询
    onSearch() {
      this.onGetDataList();
    },
    // 重置
    onReset() {
      this.pageParams.pageNum = 1;
      this.pageParams.pageSize = 10;
      Object.keys(this.queryParams).forEach(key => {
        this.queryParams[key] = ""; // 你可以根据需要调整重置的值（例如：'' 或者 null）
      });
      this.onSearch();
    },
    // 分页方法
    onChangePages(pageInfo) {
      this.pageParams.pageNum = pageInfo.page;
      this.pageParams.pageSize = pageInfo.limit;
      this.onGetDataList();
    }
  }
};
</script>
<style lang="less" scoped>
.analyse-container {
  display: flex;
  height: 95vh;
}

.form-item-width {
  width: 250px;
}

.right-btns {
  position: absolute;
  right: 20px !important;
}

.border-bottom {
  border-bottom: 1px solid #e2e2e4;
}

.margin-top {
  margin-top: -15px;
}

.custom-tree-node {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  .tree-node-label {
    font-size: 12px;
    font-weight: bold;
  }
}
</style>
